import { formatUploadDate, uploadDateMillis } from './uploadDate';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Avatar, Button, FormControl, Link } from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import SingleSelectTreeView from './SingleSelectTreeView';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const HomeworkInfoForStudent = ({ student, homework, selectedTeacher }) => {
  const [selectedDate, setSelectedDate] = useState(
    homework?.createdDate?.seconds
      ? dayjs(new Date(homework.createdDate.seconds * 1000))
      : dayjs()
  );
  const [subject, setSubject] = useState(homework?.subject || '');
  const [homeworkContent, setHomeworkContent] = useState(homework?.homework || '');
  const [fileTeacher] = useState(
    [...(homework?.fileTeacher || [])].sort((a, b) => {
      const aTime = uploadDateMillis(a.createdDate);
      const bTime = uploadDateMillis(b.createdDate);
      return bTime - aTime;
    })
  );

  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12} md={5} lg={6}>
          <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar src={selectedTeacher?.photoUrl} sx={{ width: 60, height: 60 }} />
              {selectedTeacher?.displayName}
            </Grid>

            <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  readOnly
                  value={selectedDate}
                  onChange={setSelectedDate}
                  sx={{ paddingBottom: 2 }}
                />
              </LocalizationProvider>

              <FormControl size="small" sx={{ mt: 1 }}>
                <SingleSelectTreeView
                  disabled={true}
                  selectedSubject={subject}
                  onSelect={setSubject}
                />
              </FormControl>
            </Grid>
          </Grid>

          <TextField
            InputProps={{ readOnly: true }}
            autoFocus
            required
            margin="dense"
            id="homework"
            name="homework"
            label="Homework"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={homeworkContent}
            onChange={(e) => setHomeworkContent(e.target.value)}
            sx={{ mt: 2 }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={7}
          lg={6}
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
        >
          <Button
            disabled
            component="label"
            variant="contained"
            startIcon={<CloudUploadIcon />}
          >
            Files From Teacher
            <VisuallyHiddenInput type="file" />
          </Button>

          {fileTeacher &&
            fileTeacher.map((file) => (
              <Grid
                item
                width="80%"
                p={1}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  '&:hover': { backgroundColor: '#e3f2fd' },
                }}
                key={file.savedName || file.fileName}
              >
                <Link
                  href={file.fileUrl}
                  target="_blank"
                  underline="hover"
                  sx={{
                    display: 'block',
                    width: '100%',
                    wordBreak: 'break-all',
                    whiteSpace: 'normal',
                  }}
                >
                  {file.fileName}
                </Link>

                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    mt: 0.5,
                    color: 'text.secondary',
                  }}
                >
                  {formatUploadDate(file.createdDate)}
                </Typography>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default HomeworkInfoForStudent;